import { createContext, useContext, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const NavigationContext = createContext({
  scrollToPlans: () => {},
  scrollToCurriculum: () => {},
  scrollToReferral: () => {},
  plansRef: { current: null },
  courseCurriculumRef: { current: null },
  referralRef: { current: null },
});

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider = ({ children }) => {
  const plansRef = useRef(null);
  const courseCurriculumRef = useRef(null);
  const referralRef = useRef(null);
  const [searchParams] = useSearchParams();

  const scrollToRef = (ref, offset = -100) => {
    if (ref.current) {
      const top = ref.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: top + offset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const scrollTarget = searchParams.get("scrollTo");

    if (scrollTarget === "referral") {
      setTimeout(() => {
        scrollToReferral();
      }, 300);
    }
  }, [searchParams]);

  const scrollToPlans = () => scrollToRef(plansRef);
  const scrollToCurriculum = () => scrollToRef(courseCurriculumRef);
  const scrollToReferral = () => scrollToRef(referralRef, -200);

  return (
    <NavigationContext.Provider
      value={{ scrollToPlans, plansRef, scrollToCurriculum, courseCurriculumRef, scrollToReferral, referralRef }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
